"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionChangeState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_state_group_1 = require("../../components/input/input.state.group");
var CollectionChangeState = /** @class */ (function () {
    function CollectionChangeState() {
        this.startTime = Date.now();
        this.state = new input_state_group_1.IkeInputStateGroup();
        this.state.isLabelShown = false;
    }
    CollectionChangeState.prototype.getState = function (fieldId) {
        return this.state.get(fieldId);
    };
    CollectionChangeState.prototype.addState = function (fieldId, state) {
        state.id = fieldId;
        this.state.add(state);
    };
    Object.defineProperty(CollectionChangeState.prototype, "isValid", {
        get: function () {
            return this.state.isValid;
        },
        enumerable: false,
        configurable: true
    });
    CollectionChangeState.prototype.destroy = function () {
        this.state.destroy();
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], CollectionChangeState.prototype, "isValid", null);
    return CollectionChangeState;
}());
exports.CollectionChangeState = CollectionChangeState;
//# sourceMappingURL=collection.change.state.js.map